import { Suspense } from 'react';

import { TrackClick } from '~/components/TrackEvent';
import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';

import { CategoryMenu } from './CategoryMenu';
import MarketCategoryItem, { CategoryItemSkeleton } from './MarketCategoryItem';
import PlacementRenderer from '../components/PlacementRenderer';
import { usePlacementCategory } from '../queries';

const CategoryItems = () => {
  const { businessId } = useBusinessIdStore();
  const { data } = usePlacementCategory(businessId);

  return (
    <div className="grid min-h-[100px] auto-cols-auto grid-cols-5 gap-x-8 gap-y-16 px-20 py-8 pb-16">
      <CategoryMenu />
      {data?.map((gnb) => (
        <PlacementRenderer key={gnb.adGroupId} {...gnb}>
          <TrackClick
            name="clicked button in 마켓"
            properties={{
              name: 'gnb_category',
              categoryName: gnb.categoryName,
            }}
          >
            <MarketCategoryItem gnb={gnb} />
          </TrackClick>
        </PlacementRenderer>
      ))}
    </div>
  );
};

const CategorySkeleton = () => {
  return (
    <>
      {Array.from({ length: 15 }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <CategoryItemSkeleton key={index} />
      ))}
    </>
  );
};

function MarketCategory() {
  return (
    <Suspense fallback={<CategorySkeleton />}>
      <CategoryItems />
    </Suspense>
  );
}

export default MarketCategory;
